import { isDisplay } from '@/types/user';
import type { UserInfo } from '@/types/user';

/**
 * The one path that more than one module has to agree on.
 *
 * The operations board is where every role lands, so five places name it: the route,
 * the catch-all redirect, the brand link, the navigation link, and where login sends
 * a reader who arrived without a destination of their own. A string typed five times
 * is a string that can differ in five ways — and the failure would be a redirect
 * loop or a dead link, neither of which the compiler would catch.
 *
 * The other screens are named where they are routed and linked, twice each, and are
 * not load-bearing in the same way: getting one wrong is a link that 404s to the
 * board, not an app that cannot start.
 */
export const SCHEDULE_PATH = '/schedule';

/** The flight map — and, for a wall screen, the whole of the app. */
export const MAP_PATH = '/map';

/**
 * Where a reader belongs when the screen they asked for is not theirs: the board for
 * people, the map for a wall screen, which may open nothing else.
 */
export const homePathOf = (user: UserInfo | null): string => (isDisplay(user) ? MAP_PATH : SCHEDULE_PATH);
